import { render, staticRenderFns } from "./ChatNote.vue?vue&type=template&id=124f2a0c&scoped=true"
import script from "./ChatNote.vue?vue&type=script&lang=js"
export * from "./ChatNote.vue?vue&type=script&lang=js"
import style0 from "./ChatNote.vue?vue&type=style&index=0&id=124f2a0c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "124f2a0c",
  null
  
)

export default component.exports